export default "__VITE_PUBLIC_ASSET__62c28f41__"